import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Dashboard from "../Pages/DashBoard";
import BuyNow from "../Pages/BuyNow/BuyNow";
import ICOAdmin from "../Pages/ICOAdmin";
import VestingAdmin from "../Pages/VestingAdmin";
import LandingPage from "../Pages/WelcomPage/LandingPage";
// import TermsAndConditions from "../Pages/Privacy/TermsAndConditions";
// import PrivacyPolicy from "../Pages/Privacy/PrivacyPolicy";
// import Disclaimer from "../Pages/Disclaimer/Disclaimer";

import { useAccount } from "wagmi"


const CommonRoutes = () => {

  const { isConnected } = useAccount()

  console.log("isConnected==>",isConnected)

  return (
    <div>
      <Routes>
        <Route
          path="*"
          element={<Navigate to={isConnected ? "/buynow" : "/"} />}
        />
        {/* {!isConnected && (
          <>
            <Route path="/" element={<LandingPage />} />
          </>
        )} */}
        {/* {isConnected && ( */}
        <>
          <Route path="/" element={<LandingPage />} />
          <Route extact path="/dashboard" element={<Dashboard />} />
          <Route extact path="/buynow" element={<BuyNow />} />
          <Route extact path="/withdraw-admin" element={<ICOAdmin />} />
          <Route extact path="/whitelist-admin" element={<VestingAdmin />} />
          {/* <Route path="/termsandconditions" element={<TermsAndConditions />} /> */}
          {/* <Route path="/privacypolicy" element={<PrivacyPolicy />} /> */}
          {/* <Route path="/disclaimer" element={<Disclaimer />} /> */}
        </>
        {/* )} */}
      </Routes>
    </div>
  );
};

export default CommonRoutes;
